import { customAlphabet } from 'nanoid'

export const getRandomCode = (length = 8) => {
  const nanoid = customAlphabet('0123456789ABCDEFGHJKLMNPQRSTUVWXYZ', length)
  return nanoid();
}